import { classnames } from '@aibees/shared/utils';
import { TeamMemberFilterProvider } from '@aibees/shared/views/user-management-view/context/team-member-filter-context';
import { memo } from 'react';
import { CreditTeamMember } from '../current-plan/features/credit-team-member';
import { CreditUsageFilters } from '../current-plan/features/team-credit-usage/components/credit-usage-filters';
import { TotalCreditBalance } from '../current-plan/features/team-credit-usage/components/total-credit-balance';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditUsageProps as Props } from './types';

export const CreditUsage = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('CreditUsage', className)}
      sx={SX.root}
    >
      <TeamMemberFilterProvider>
        <CreditUsageFilters />
        <TotalCreditBalance />
        <CreditTeamMember />
      </TeamMemberFilterProvider>
    </Styled.Wrapper>
  );
});

CreditUsage.displayName = 'CreditUsage';
